// import { outbrainProvider } from './outbrain'
// import { taboolaProvider } from './taboola'
import { dplxapiProvider } from './dplxapi'
import type { ApiAdProvider, ClientAdProvider } from './types'

/**
 * Union type for all ad provider types
 * Allows registry to contain both API-based and client-side providers
 */
export type AllAdProvider = ApiAdProvider | ClientAdProvider

export const clientAdProviders: Record<string, ClientAdProvider> = {
  // outbrain: outbrainProvider,
  // taboola: taboolaProvider,
}

export const apiAdProviders: Record<string, ApiAdProvider> = {
  dplxapi: dplxapiProvider,
}

/**
 * Central registry of all available ad providers
 * Providers are keyed by their name identifier
 */
export const allAdProviders: Record<string, AllAdProvider> = {
  // outbrain: outbrainProvider,
  // taboola: taboolaProvider,
  dplxapi: dplxapiProvider,
}
